const SolomonIslandsSvg = () => (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_4152_112374)">
      <path
        d="M34.1424 34.1439C41.6433 26.643 41.9394 14.6677 35.0341 6.81152L19.9997 20.0011L6.81006 35.0355C14.6662 41.9409 26.6415 41.6447 34.1424 34.1439Z"
        fill="#496E2D"
      />
      <path
        d="M5.8573 5.85733C13.3581 -1.64351 25.3335 -1.93968 33.1897 4.9657L19.9999 20.0002L4.96573 33.1897C-1.93972 25.3335 -1.64347 13.3582 5.8573 5.85733Z"
        fill="#0052B4"
      />
      <path
        d="M33.1893 4.96582L4.96533 33.1898C5.25064 33.5144 5.54689 33.8329 5.85697 34.1428C6.16697 34.4528 6.48549 34.749 6.81017 35.0345L35.0339 6.8105C34.7486 6.48582 34.4523 6.16738 34.1422 5.8573C33.8324 5.54746 33.5139 5.25113 33.1893 4.96582Z"
        fill="#FFDA44"
      />
      <path
        d="M8.42681 6.95703L8.85861 8.2857H10.2556L9.12541 9.10671L9.55705 10.4354L8.42681 9.61421L7.29658 10.4354L7.72838 9.10671L6.59814 8.2857H7.99517L8.42681 6.95703Z"
        fill="#F0F0F0"
      />
      <path
        d="M15.5626 6.95703L15.9944 8.2857H17.3912L16.2611 9.10671L16.6928 10.4354L15.5626 9.61421L14.4323 10.4354L14.8641 9.10671L13.7339 8.2857H15.1308L15.5626 6.95703Z"
        fill="#F0F0F0"
      />
      <path
        d="M8.42681 13.9131L8.85861 15.2418H10.2556L9.12541 16.0628L9.55705 17.3915L8.42681 16.5703L7.29658 17.3915L7.72838 16.0628L6.59814 15.2418H7.99517L8.42681 13.9131Z"
        fill="#F0F0F0"
      />
      <path
        d="M15.5626 13.9131L15.9944 15.2418H17.3912L16.2611 16.0628L16.6928 17.3915L15.5626 16.5703L14.4323 17.3915L14.8641 16.0628L13.7339 15.2418H15.1308L15.5626 13.9131Z"
        fill="#F0F0F0"
      />
      <path
        d="M11.9948 10.4346L12.4266 11.7632H13.8234L12.6933 12.5843L13.125 13.913L11.9948 13.0918L10.8645 13.913L11.2962 12.5843L10.166 11.7632H11.563L11.9948 10.4346Z"
        fill="#F0F0F0"
      />
    </g>
    <defs>
      <clipPath id="clip0_4152_112374">
        <rect width="40" height="40" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
export default SolomonIslandsSvg;
